export const sortLegendKeys = (a, b) => {
  if (a.includes('Network') || a.includes('Channel')) {
    return 1
  } else if (b.includes('Network') || b.includes('Channel')) {
    return -1
  } else {
    return b - a
  }
}
